import './ProjectsComponent.scss'

import ProjectCard from '../ProjectCard/ProjectCard'
import React from 'react'

function ProjectsComponent() {

  const projectList = [
    {
      projectNumber: "6",
      projectName: "DIB" ,
      projectTitle: "Digital Impact Builders",
      projectDescription: "A quick and easy web application to lookup your match history!",
      projectTechStack: ["Next.js", "Tailwind", "Axios", "Custom API", "MongoDB"],
      projectExtLink: "",
      projectGitHub: "https://github.com/simontcodes/DIB-front",
      projectTimestamp: "Ongoing",
      projectCaseStudyDone: false,
    },
    {
      projectNumber: "5",
      projectName: "10Latest" ,
      projectTitle: "10Latest",
      projectDescription: "A quick and easy web application to lookup your match history!",
      projectTechStack: ["React", "Axios", "Riot Games API"],
      projectExtLink: "https://10latest.netlify.app",
      projectGitHub: "https://github.com/Gachuka/lol-summoner-stats",
      projectTimestamp: "February 2023",
      projectCaseStudyDone: true,
    },
    {
      projectNumber: "4",
      projectName: "7Shifts-hackathon" ,
      projectTitle: "7Shifts Hackathon",
      projectDescription: "A hackathon done in collaboration with 7Shifts",
      projectTechStack: ["React"],
      projectExtLink: "https://7shifts-hack-a-thon.netlify.app",
      projectGitHub: "https://github.com/Gachuka/seven-shifts-hackathon",
      projectTimestamp: "September 2022",
      projectCaseStudyDone: true,
    },
    {
      projectNumber: "3",
      projectName: "image-resizer" ,
      projectTitle: "Image Resizer",
      projectDescription: "A quick desktop application to resize your images",
      projectTechStack: ["Electron.js", "HTML", "CSS"],
      projectExtLink: "",
      projectGitHub: "https://github.com/Gachuka/electron-image-resizer",
      projectTimestamp: "December 2022",
      projectCaseStudyDone: false,
    },
    {
      projectNumber: "2",
      projectName: "terrible-dating-app" ,
      projectTitle: "Terrible Dating App",
      projectDescription: "A dating app that will match you with your opposite!!",
      projectTechStack: ["React", "Axios", "Express", "MySQL"],
      projectExtLink: "",
      projectGitHub: "https://github.com/Gachuka/terribledatingapp",
      projectTimestamp: "October 2022",
      projectCaseStudyDone: false,
    },
    {
      projectNumber: "1",
      projectName: "productivity-idle" ,
      projectTitle: "Productivity.Idle",
      projectDescription: "A simple gamified productivity tracker that will motivate you to keep on typing!!",
      projectTechStack: ["REact", "Axios", "MySQL", "Webpack"],
      projectExtLink: "",
      projectGitHub: "https://github.com/Gachuka/productivity.idle",
      projectTimestamp: "September 2022",
      projectCaseStudyDone: false,
    },
  ]

  return (
    <section className='projects' id='projects'>
      <div className='projects__container'>
        <h1 className='projects__header'>Some Things I've Built and Working On</h1>

        <div className='projects__showcase'>

          {projectList.map((project) => {
            return <ProjectCard 
              key={project.projectNumber} 
              projectName={project.projectName} 
              projectTitle={project.projectTitle}
              projectDescription={project.projectDescription}
              projectTechStack={project.projectTechStack}
              projectExtLink={project.projectExtLink}
              projectGitHub={project.projectGitHub}
              projectTimestamp={project.projectTimestamp}
              projectCaseStudyDone={project.projectCaseStudyDone}
            />
          })}

          {/* <div className='project__card card'>
            <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
            <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
            <div className='card__container'>
              <a target="_blank" rel="noreferrer" className='card__case-study' href="./10latest">Case Study</a>
              <div className='card__bg'>
                <img src={Project10LatestDemo} className="card__preview" alt="project preview"/>
              </div>
              <div className='card__header'>
                <div className='card__top'>
                  <ul className='card__link-list'>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://10latest.netlify.app" className="social__external-link">
                        <img src={ExternalLink} alt="external link" className="card__external-link" />
                      </a>
                    </li>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://github.com/Gachuka/terribledatingapp" className="social__github-link">
                        <img src={SmallGitHub} alt="github link" className="card__github" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h3 className='card__title'>LoL Summoner Match History</h3>
                <p className='card__description'>
                  A quick and easy web application to lookup your match history!
                </p>
              </div>
              <div className='card__footer'>
                <ul className='card__tech-stack-list'>
                  <li className='card__tech-stack-items'>React</li>
                  <li className='card__tech-stack-items'>Axios</li>
                  <li className='card__tech-stack-items'>Riot Games API</li>
                </ul>
              </div>
            </div>
          </div> */}

          {/* <div className='project__card card'>
            <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
            <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
            <div className='card__container'>
              <div className='card__bg'>
                <img src={Project7ShiftsHackathonDemo} className="card__preview" alt="project preview"/>
              </div>
              <a target="_blank" rel="noreferrer" className='card__case-study' href="./7shifts">Case Study</a>
              <div className='card__header'>
                <div className='card__top'>
                  <ul className='card__link-list'>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://7shifts-hack-a-thon.netlify.app" className="social__external-link">
                        <img src={ExternalLink} alt="external link" className="card__external-link" />
                      </a>
                    </li>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://github.com/Gachuka/seven-shifts-hackathon" className="social__github-link">
                        <img src={SmallGitHub} alt="github link" className="card__github" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h3 className='card__title'>7Shifts Hackathon</h3>
                <p className='card__description'>
                  A hackathon done in collaboration with 7Shifts.
                </p>
              </div>
              <div className='card__footer'>
                <ul className='card__tech-stack-list'>
                  <li className='card__tech-stack-items'>React</li>
                </ul>
              </div>
            </div>
          </div> */}

          {/* <div className='project__card card'>
            <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
            <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
            <div className='card__container'>
              <div className='card__bg'>
              </div>
              <a target="_blank" rel="noreferrer" className='card__case-study' href="./under-construction">Case Study</a>
              <div className='card__header'>
                <div className='card__top'>
                  <ul className='card__link-list'>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://github.com/Gachuka/terribledatingapp" className="social__github-link">
                        <img src={SmallGitHub} alt="github link" className="card__github" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h3 className='card__title'>Terrible Dating App</h3>
                <p className='card__description'>
                  A dating app that will match you with your opposite!!
                </p>
              </div>
              <div className='card__footer'>
                <ul className='card__tech-stack-list'>
                  <li className='card__tech-stack-items'>React</li>
                  <li className='card__tech-stack-items'>Axios</li>
                  <li className='card__tech-stack-items'>Express</li>
                  <li className='card__tech-stack-items'>MySQL</li>
                </ul>
              </div>
            </div>
          </div> */}

          {/* <div className='project__card card'>
            <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
            <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
            <div className='card__container'>
              <div className='card__bg'>
              </div>
              <a target="_blank" rel="noreferrer" className='card__case-study' href="./under-construction">Case Study</a>
              <div className='card__header'>
                <div className='card__top'>
                  <ul className='card__link-list'>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://github.com/Gachuka/electron-image-resizer" className="social__github-link">
                        <img src={SmallGitHub} alt="github link" className="card__github" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h3 className='card__title'>Image Resizer</h3>
                <p className='card__description'>
                  A quick desktop application to resize your images
                </p>
              </div>
              <div className='card__footer'>
                <ul className='card__tech-stack-list'>
                  <li className='card__tech-stack-items'>Electron.js</li>
                  <li className='card__tech-stack-items'>HTML</li>
                  <li className='card__tech-stack-items'>CSS</li>
                </ul>
              </div>
            </div>
          </div> */}

          {/* <div className='project__card card'>
            <img className='card__thumbtack-back' src={ThumbTackBack} alt="project tag" />
            <img className='card__thumbtack' src={ThumbTack} alt="project tag" />
            <div className='card__container'>
              <div className='card__bg'>
              </div>
              <a target="_blank" rel="noreferrer" className='card__case-study' href="./under-construction">Case Study</a>
              <div className='card__header'>
                <div className='card__top'>
                  <ul className='card__link-list'>
                    <li className='card__link-items'>
                      <a target="_blank" rel="noreferrer" href="https://github.com/Gachuka/productivity.idle" className="social__github-link">
                        <img src={SmallGitHub} alt="github link" className="card__github" />
                      </a>
                    </li>
                  </ul>
                </div>
                <h3 className='card__title'>Productivity.Idle</h3>
                <p className='card__description'>
                  A simple gamified productivity tracker that will motivate you to keep on typing!!
                </p>
              </div>
              <div className='card__footer'>
                <ul className='card__tech-stack-list'>
                  <li className='card__tech-stack-items'>React</li>
                  <li className='card__tech-stack-items'>Axios</li>
                  <li className='card__tech-stack-items'>MySQL</li>
                  <li className='card__tech-stack-items'>Webpack</li>
                </ul>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </section>
  )
}

export default ProjectsComponent